exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-success {\r\n  font-size: 18px;\r\n  margin-top: 12px;\r\n  display: inline-block;\r\n}\r\n\r\n.feedback-success i {\r\n  color: #26B99A;\r\n}\r\n\r\n.tippBox {\r\n  margin-top: 16px;\r\n  padding: 12px;\r\n  background-color: rgba(102, 204, 255, 0.3);\r\n  max-width: 600px;\r\n}\r\n\r\n.tippBox .tippTitle {\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n}\r\n\r\n.causeCaption, .tippCaption, .explanationCaption{\r\n  text-decoration: underline;\r\n  font-weight: bold;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/questionnaire-details/questionnaire-details.component.css
// module id = ../../../../../src/app/components/questionnaire-details/questionnaire-details.component.css
// module chunks = 0